import Image from "next/image"
import { Fragment } from "react"

interface CustomerLogoStripProps {
  logos: Array<{ srcLight: string; srcDark: string; alt: string }>
  title?: string
}

function getGridColsClass(logoCount: number): string {
  if (logoCount <= 3) {
    return "grid-cols-1 md:grid-cols-3"
  }
  if (logoCount >= 5) {
    return "grid-cols-2 md:grid-cols-3 lg:grid-cols-5"
  }
  return "grid-cols-2 md:grid-cols-4"
}

export function CustomerLogoStrip({
  logos,
  title = "Trusted by",
}: CustomerLogoStripProps) {
  const gridColsClass = getGridColsClass(logos.length)

  return (
    <div className="flex flex-col gap-2 items-center pt-16 pb-32">
      <div className="text-fg-secondary text-base mb-4 lg:mb-6">{title}</div>
      <div className="w-full flex justify-center">
        <div
          className={`grid ${gridColsClass} gap-2 items-center justify-items-center max-w-[900px]`}
        >
          {logos.map((logo) => (
            <Fragment key={logo.srcLight}>
              <Image
                src={logo.srcLight}
                alt={logo.alt}
                width={520}
                height={500}
                className="w-full h-[120px] block dark:hidden"
              />
              <Image
                src={logo.srcDark}
                alt={logo.alt}
                width={520}
                height={500}
                className="w-full h-[120px] hidden dark:block"
              />
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}
